import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed';
import { BookingPeriods } from './containers/BookingPeriods';
import { CreditCardReceipts } from './containers/CreditCardReceipts';

export const Finances = {
  Helmet: lazy(() => import('./components/Helmet')),
  Invoices: lazy(() => import('./containers/Invoices')),
  ManualInvoice: lazy(() => import('./containers/ManualInvoice')),
  CompanyConfigs: {
    ConfigsList: lazyNamed(() => import('./containers/CompanyConfigs/pages/ConfigsList'), 'ConfigsList'),
    ConfigForm: lazyNamed(() => import('./containers/CompanyConfigs/pages/ConfigForm'), 'ConfigForm'),
  },
  Payouts: {
    Report: lazy(() => import('./containers/Payouts/containers/Reports')),
    Statistics: lazy(() => import('./containers/Payouts/containers/Statistics')),
    Websites: lazyNamed(() => import('./containers/Payouts/containers/Websites'), 'Websites'),
    WebsiteForm: lazyNamed(() => import('./containers/Payouts/containers/WebsiteForm'), 'WebsiteForm'),
    PayoutConfigs: lazyNamed(() => import('./containers/Payouts/containers/PayoutConfigs'), 'PayoutConfigs'),
    Positions: lazyNamed(() => import('./containers/Payouts/containers/Positions'), 'Positions'),
    Details: lazyNamed(() => import('./containers/Payouts/containers/Details'), 'Details'),
    PayoutConfigForm: lazyNamed(() => import('./containers/Payouts/containers/PayoutConfigForm'), 'PayoutConfigForm'),
    CustomPayoutIdRanges: lazyNamed(() => import('./containers/Payouts/containers/CustomPayoutIdRanges'), 'CustomPayoutIdRanges'),
  },
  Payments: lazyNamed(() => import('./containers/Payments'), 'Payments'),
  CreditCardReceipts,
  BookingPeriods,
};
